query GetTrackingSnippetStatus {
    analyticsStatus {
        status
        domain
        lastBootConfigAccessTime
    }
}
